/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';

export class payerproviderreferenceidentification extends IceEntity {
  payer_provider_reference_identification_key: string = "";
  payer_trans_account: string = "";
  identification_key: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "PAYER_PROVIDER_REFERENCE_IDENTIFICATION";
  }
}
